export const NUMBER_WARNING_ICON_TEST_ID = 'issue-field-number.edit.warning-icon';
